import ApiKeysSettings from '@/pages/settings/api-keys';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/api-keys'
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <ApiKeysSettings />;
}
